function useErrorHelper(errors, errorVisibility, helperText, fieldStatus) {
  const fieldInvalid = fieldStatus === "invalid";
  const fieldIndeterminate = fieldStatus === "indeterminate";
  const showErrorText = errorVisibility === "all" || errorVisibility === "text-only";
  const showErrorAccent = errorVisibility === "all" || errorVisibility === "accent-only";
  const fieldHasError = fieldInvalid || fieldIndeterminate && errors.length > 0;
  const errorText = fieldHasError ? errors[0]?.message ?? "Unknown Error" : void 0;
  const errorOrHelperText = showErrorText && fieldHasError ? errorText : helperText;
  const showHelperText = !!errorOrHelperText;
  return {
    errorOrHelperText,
    errorText,
    fieldHasError,
    showErrorAccent,
    showErrorText,
    showHelperText
  };
}
export {
  useErrorHelper
};
//# sourceMappingURL=useErrorHelper.js.map
